import type { ParameterDimensionDefinitionInOut } from '@festina/configuration-general-types/configuration'
import { Tooltip } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { Card, CardBody } from '@festina-life/ui/structure'

import { DocumentationEntry } from '../../../components/documentationEntry/DocumentationEntry'
import { useLayoutContext } from '../../../context/layoutContext'

type Props = {
  data: ParameterDimensionDefinitionInOut
}

export const ParameterDimensionNameCell = ({ data }: Props) => {
  const translate = useTranslate()
  const { preferences } = useLayoutContext()

  return (
    <Tooltip
      tip={
        preferences.common.isShowingDocumentationOnHover ? (
          <Card>
            <CardBody
              outerClassName="min-w-250 max-w-(--breakpoint-2xl)"
              innerClassName="grid grid-cols-[auto_1fr] items-start gap-x-10 gap-y-6"
            >
              <DocumentationEntry
                title={translate(
                  'parameterViewer.dimensionDetails.description',
                )}
                value={data.description || '-'}
              />
            </CardBody>
          </Card>
        ) : null
      }
      className="h-full grow"
    >
      <div className="flex size-full items-center justify-start">
        <h4 className="m-0 pl-2 font-medium">{data.name}</h4>
      </div>
    </Tooltip>
  )
}
